import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { PUBLICATIONS_TAG_TYPE } from './constants';

export interface Publication {
  id: string;
  url: string;
  description: string;
  title?: string;
  authors?: string[];
  journal?: string;
  year?: number;
  pmid?: string;
  [key: string]: unknown;
}

export interface PublicationsResponse {
  results?: Publication[];
  count?: number;
  [key: string]: unknown;
}

export const publicationsApi = createApi({
  reducerPath: 'publicationsApi',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [PUBLICATIONS_TAG_TYPE],
  endpoints: (builder) => ({
    getPublications: builder.query<PublicationsResponse, { providerId: string }>(
      {
        query: ({ providerId }) => ({
          url: `v1/hcp/${providerId}/publications/`,
          method: 'GET',
        }),
        providesTags: (result, error, { providerId }) => [
          { type: PUBLICATIONS_TAG_TYPE, id: providerId },
        ],
      }
    ),
  }),
});

export const { useGetPublicationsQuery } = publicationsApi;
